export default "__VITE_ASSET__Dz_W2j_X__"